import { Link } from "react-router-dom";
import { ProjectLogo } from "./Logo";
import { useLang } from "../i18n";

const headingCls = "mb-5 block font-mono text-xs font-semibold uppercase tracking-[0.2em] text-white/40";
const linkCls = "link-underline w-fit text-sm font-medium text-fog transition-colors duration-300 hover:text-white";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-void">
      <div className="mx-auto max-w-6xl px-6 py-14">
        <div className="grid items-start gap-12 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <ProjectLogo className="h-9 w-9 shrink-0" />
              <p data-testid="footer-brand" className="font-display text-2xl font-bold tracking-tight">
                The Lifespan Project
              </p>
            </div>
            <p className="mt-4 max-w-md text-base font-light leading-relaxed text-fog">
              {t("footer.desc", "A multidisciplinary human-longevity research initiative, engineering the next 150 years of human life.")}
            </p>
          </div>
          <nav className="lg:col-span-2" aria-label="Explore">
            <span data-testid="footer-explore-heading" className={headingCls}>{t("footer.explore", "Explore")}</span>
            <div className="flex flex-col gap-3">
              <Link to="/" data-testid="footer-home-link" className={linkCls}
                onClick={() => { if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true }); else window.scrollTo(0, 0); }}>
                {t("nav.home", "Home")}
              </Link>
              <Link to="/subscribe" data-testid="footer-back-us-link" className={linkCls}>{t("nav.backus", "Subscribe")}</Link>
              <Link to="/assessment?src=footer" data-testid="footer-assessment-link" className={linkCls}>Free Level 0 Assessment</Link>
              <Link to="/back-us" data-testid="footer-invest-link" className={linkCls}>{t("nav.invest", "Back Us")}</Link>
              <Link to="/apply" data-testid="footer-join-us-link" className={linkCls}>{t("nav.join", "Apply")}</Link>
            </div>
          </nav>
          <div className="min-w-0 lg:col-span-3">
            <span data-testid="footer-contact-heading" className={headingCls}>{t("footer.contact", "Contact")}</span>
            <div className="flex flex-col gap-3">
              <a href="mailto:invest@thelifespanproject.com" data-testid="footer-email-link" className={linkCls}>
                invest@thelifespanproject.com
              </a>
              <span data-testid="footer-domain" className="text-sm font-medium text-fog">thelifespanproject.com</span>
            </div>
          </div>
          <nav className="lg:col-span-3" aria-label="Legal">
            <span data-testid="footer-legal-heading" className={headingCls}>{t("footer.legal", "Legal")}</span>
            <div className="flex flex-col gap-3">
              <Link to="/terms" data-testid="footer-terms-link" className={linkCls}>{t("footer.terms", "Terms")}</Link>
              <Link to="/privacy" data-testid="footer-privacy-link" className={linkCls}>{t("footer.privacy", "Privacy Policy")}</Link>
              <Link to="/refund" data-testid="footer-refund-link" className={linkCls}>{t("footer.refund", "Refund Policy")}</Link>
              <Link to="/faq" data-testid="footer-faq-link" className={linkCls}>{t("footer.faq", "FAQs")}</Link>
            </div>
          </nav>
        </div>
        <div className="mt-14 border-t border-white/5 pt-8">
          <p data-testid="footer-partners-label" className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
            {t("footer.partners", "Technology Partners & Backers")}
          </p>
          <div data-testid="footer-partners" className="mt-3 flex flex-col gap-1.5 text-base font-medium text-fog">
            <span>Ajubax Ai Inc., Canada</span>
            <span>Addrish, India</span>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-4 text-base text-white/30 md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-copyright">{t("footer.copyright", "© 2026 The Lifespan Project. All rights reserved.")}</span>
          <span className="text-gradient">{t("footer.tagline", "Immortality is theoretical. 150 years is practical.")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
